import profileStyles from "../../styles/userProfile.module.css";
import { BagstageUserDetails } from "../../types/user.types";

export default function UserProfile({
  bagstageUser
}: {
  bagstageUser: BagstageUserDetails;
}) {
  return (
    <>
      {bagstageUser.userName && (
        <p className={profileStyles.username}>{bagstageUser.userName}</p>
      )}
      {bagstageUser.userEmail && (
        <p className={profileStyles.useremail}>{bagstageUser.userEmail}</p>
      )}
    </>
  );
}
